<template>
  <div>
    <ContentSectionLoader v-show="!loaded" />
    <div
      v-show="loaded"
      class="flex flex-wrap justify-between my-2"
    >
      <AccessRequestsFilter
        v-if="isSearchable"
        v-model="queryString"
      />
      <div
        v-if="pendingAccessRequests.data.length"
        class="w-full sm:w-1/5"
      >
        <div class="input-group pt-3 pb-2 pl-3 sm:mr-8">
          <div>
            <input
              id="approve-all"
              v-model="approveAll"
              type="checkbox"
              name="approve-all"
            >
            <label
              for="approve-all"
              v-text="'Approve All Pending Requests'"
            />
          </div>
        </div>
      </div>
    </div>
    <Transition name="fade">
      <div v-if="loaded">
        <div v-if="pendingAccessRequests.data.length">
          <div
            is="AccessRequestDay"
            v-for="(accessRequestDay, index) in accessRequestDays"
            :key="`access-request-day-${index}`"
            :access-request-day="accessRequestDay"
            :approve-all="approveAll"
          />
        </div>
        <div
          v-else
          class="empty"
        >
          <section>
            <h2 v-text="noResultsText" />
            <p>
              Members can self register at
              <a
                :href="registrationUrl"
                target="_blank"
                rel="noopener noreferrer"
                v-html="registrationUrl"
              />.
            </p>
          </section>
        </div>
      </div>
    </Transition>
    <div
      v-if="accessRequestApprovalQueue.length"
      class="fixed text-center pin-x py-4 pin-b bg-grey-light border-t border-grey-dark"
      style="z-index: 1001;"
    >
      <button
        type="button"
        class="btn btn-blue"
        :class="{ load: isLoading }"
        @click.prevent="submitAccessRequestApprovalQueue"
        v-html="approveButtonText"
      />
      <button
        v-if="!isLoading"
        type="button"
        class="mx-4 px-2"
        @click.prevent="resetAccessRequestApprovalQueue"
        v-text="'Cancel'"
      />
    </div>
  </div>
</template>

<script type="text/babel">
import URI from 'urijs'
import { mapActions } from 'vuex'
import AccessRequestDay from './AccessRequestDay'
import AccessRequestsFilter from './AccessRequestsFilter'

export default {
  name: 'AccessRequests',
  components: {
    AccessRequestsFilter,
    AccessRequestDay,
  },
  data() {
    return {
      loaded: false,
      isLoading: false,
      queryString: {
        query: '',
        page: 1,
      },
      approveAll: false,
    }
  },
  computed: {
    isSearchable() {
      return (this.pendingAccessRequests.data.length && this.queryString.query === '') || this.queryString.query !== ''
    },
    registrationUrl() {
      return this.$urlGenerator.public()
    },
    approveButtonText() {
      return this.isLoading
        ? 'Approving requests...'
        : `Approve selected requests (${this.accessRequestApprovalQueue.length})`
    },
    pendingAccessRequests() {
      return this.$store.getters.membershipPendingAccessRequests
    },
    accessRequestDays() {
      if (this.pendingAccessRequests.data.length) {
        const vm = this

        return _.groupBy(this.pendingAccessRequests.data, function (accessRequest) {
          return vm.moment(accessRequest.attributes.created_at).startOf('day').format()
        })
      }

      return []
    },
    accessRequestApprovalQueue() {
      return this.$store.state.membership.accessRequestApprovalQueue
    },
    fetchUrl() {
      return new URI('').setSearch(this.queryString).toString()
    },
    noResultsText() {
      return this.queryString.query
        ? `No approvals pending matching "${this.queryString.query}"`
        : 'No approvals pending'
    },
    paymentsEnabled() {
      return this.$root.Union.payments_enabled
    },
  },
  watch: {
    queryString: {
      handler: _.debounce(function () {
        this.queryString.page = 1

        history.pushState(null, null, this.fetchUrl)

        this.fetch()

        this.approveAll = false
      }, 500),
      deep: true,
    },
    approveAll(value) {
      this.pendingAccessRequests.data.forEach((accessRequest) => {
        if (!value) {
          this.$store.commit('membershipRemoveApprovalForAccessRequest', accessRequest)
        }
      })
    },
  },
  async mounted() {
    await this.$nextTick()

    this.queryString = Object.assign(this.queryString, new URI().query(true))

    this.fetch()

    this.$store.dispatch('authGetRoles')

    if (this.paymentsEnabled) {
      this.getMembershipFee()
    }
  },
  methods: {
    ...mapActions({
      getMembershipFee: 'paymentsGetMembershipFee',
    }),
    fetch() {
      Promise.all([
        this.$store.dispatch('membershipGetPendingAccessRequests', {
          params: this.queryString,
        }),
        this.$store.dispatch('organizationGetAccessRequestFields'),
      ]).then(() => {
        this.loaded = true
      })
    },
    resetAccessRequestApprovalQueue() {
      this.$store.commit('membershipResetPendingAccessRequestQueue')

      this.approveAll = false
    },
    submitAccessRequestApprovalQueue() {
      this.isLoading = true

      this.$store.dispatch('membershipSubmitAccessRequestApprovalQueue')
        .then(() => {
          this.$store.commit('baseAddNotification', {
            type: 'success',
            title: 'Success',
            text: 'Access request(s) approved!',
          })

          this.$store.dispatch('membershipGetPendingAccessRequests')

          this.isLoading = false
        }).catch(() => {
          this.$store.commit('baseAddNotification', {
            type: 'error',
            title: 'Error',
            text: 'There was a problem approving the access requests.',
            timeout: false,
          })

          this.isLoading = false
        })
    },
  },
}
</script>
